let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ccr4j")).then(() => parcelRequire('dAq4f'));